<div class="dialog">
  <h4 mat-dialog-title *ngIf="data.title">{{ data.title }}</h4>
  <!-- optional body: lets a caller keep the title short instead of putting a whole paragraph in it -->
  <div mat-dialog-content class="dialog-info__message" *ngIf="data.message">{{ data.message }}</div>
  <div mat-dialog-actions>
    <!-- closes with `true`, so a caller can tell Ok apart from a dismissal (backdrop click / ESC) -->
    <button mat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{ 'common_btn_ok' | translate }}</button>
  </div>
</div>
